var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlueArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4948 5.00985C18.3952 4.97155 18.2956 4.94857 18.1884 4.94857L8.94237 4.95623C8.49808 4.95623 8.13038 5.32392 8.13038 5.76822C8.13038 6.21252 8.49808 6.58022 8.94237 6.58022L16.2197 6.58022L5.24256 17.5573C4.92849 17.8714 4.92849 18.3923 5.24256 18.7064C5.55664 19.0205 6.07754 19.0205 6.39161 18.7064L17.3764 7.72161L17.3764 14.9989C17.3764 15.4432 17.7441 15.8109 18.1884 15.8109C18.4182 15.8109 18.6174 15.719 18.7629 15.5734C18.9085 15.4279 19.0004 15.2287 19.0004 14.9989L19.0004 5.76056C19.0004 5.65332 18.9774 5.55373 18.9391 5.45415C18.8472 5.25498 18.694 5.10178 18.4948 5.00985Z",
    fill: "#518BF8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueArrow);
export default __webpack_public_path__ + "static/media/icon_blue_arrow.2119b1c3.svg";
export { ForwardRef as ReactComponent };